import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import DeviceCard from "./DeviceCard";

const DeviceGrid = ({ devices, loading }) => {
  const showSkeletons = loading || devices.length === 0;

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
        gap: 2,
      }}
    >
      {showSkeletons
        ? Array.from({ length: 6 }).map((_, i) => (
            <DeviceCard key={`skeleton-${i}`} loading />
          ))
        : devices.map((device) => (
            <DeviceCard key={device.id} device={device} />
          ))}
    </Box>
  );
};

DeviceGrid.propTypes = {
  devices: PropTypes.array.isRequired,
  loading: PropTypes.bool,
};

export default DeviceGrid;
